import type { Nullable } from 'corgi-types';

export const getErrorMessage = (error: Nullable<string>) => {
  const ERRORS = new Map([
    ['ItemNotAddableToCartType', 'h24_item_not_addable_to_cart_type'],
    ['ItemNotExist', 'h24_item_not_exist'],
  ]);
  if (ERRORS.has(error)) {
    return ERRORS.get(error);
  }

  return error === null ? null : 'h24_something_went_wrong';
};
